/** Distinguishing signs of the EU countries, as offered in the blue band of the EU plate. */
export const EU_PLATE_COUNTRY_CODES: string[] = [
  'D', 'B', 'BG', 'DK', 'EST', 'FIN', 'F', 'GR', 'IRL', 'I', 'HR', 'LV', 'LT', 'L', 'M',
  'NL', 'A', 'PL', 'P', 'RO', 'S', 'SK', 'SLO', 'E', 'CZ', 'H', 'CY',
];

